/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(window).on('load', function() {
          $('.first-loader').fadeOut(function() {
            $('.wrapp-general-loader').delay(300).fadeOut();
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        new WOW().init();

        function checkLinkActive() {
          var links = $('a[href]');
          var cbk = function(e) {
           if(e.currentTarget.href === window.location.href) {
             e.preventDefault();
             e.stopPropagation();
             $('main').addClass('shake');
           }
          };
          for(var i = 0; i < links.length; i++) {
            links[i].addEventListener('click', cbk);
          }
        }

        function initMenu() {
          $('#fullscreen').on('click', function() {
            $(this).toggleClass('is-active');
            $('main').toggleClass('opacity');
            $('#fullscreen-menu').slideToggle();
            $('#fullscreen-menu .nav li').each(function(index, element) {
              $(this).toggleClass('animated fadeInUp delay'+(index + 1)+'');
            });
            $('html').toggleClass('no-overflow');
          });

          $('#fullscreen-menu .nav li a').on('click', function() {
            $('#fullscreen').removeClass('is-active');
            $('main').removeClass('opacity');
            $('#fullscreen-menu').slideUp();
            $('#fullscreen-menu .nav li').each(function(index, element) {
              $(this).removeClass('animated fadeInUp delay'+(index + 1)+'');
            });
            $('html').removeClass('no-overflow');
          });

          var effect_scroll;
          var last_scroll = 0;
          var delta = 5;
          var header_height = $(".navigation-wrapper").outerHeight();

          $(window).scroll(function(event){
              effect_scroll = true;
          });

          setInterval(function(){
              if(effect_scroll){
                  goEffect();
                  effect_scroll = false;
              }
          }, 200);

          function goEffect(){
              var scroll_top = $(this).scrollTop();

              if(Math.abs(last_scroll - scroll_top) <= delta)
                  return;

              if(scroll_top > last_scroll && scroll_top > header_height){
                  // scrollo giÃ¹
                  $("header").removeClass("down").addClass("up");
                  $(".menu-mobile").removeClass("down").addClass("up");
              }else{
                  // Scrollo su
                  if(scroll_top + $(window).height() < $(document).height()){
                      $(".navigation-wrapper").removeClass("up").addClass("down");
                      //$(".menu-mobile").removeClass("up").addClass("down");
                  }
              }
              last_scroll = scroll_top;
          }
        }
        // PAGE HOME
        function initHome() {
          var bkWidth, windowWidth, windowHeight;
          $(document).ready(function() {
            windowHeight = $(window).height();
            bkWidth = $('.rlt').width();
            windowWidth = $(window).width();
            if (windowWidth >= 991) {
              $('.home .wrapp-img').css("max-height", $('.mx-width').height());
              $(".home .first-section").css("height", windowHeight).addClass('bk-none');
              $('.rlt .background').css({"height": (windowHeight - $('.wrapp-bottom').outerHeight() - $('.navigation-wrapper').outerHeight()), "width" : $('.rlt').width(), "margin-top": $('.navigation-wrapper').height() });
            }
          });

          $(window).on('resize', function() {
            windowHeight = $(window).height();
            bkWidth = $('.rlt').width();
            windowWidth = $(window).width();
            if (windowWidth >= 991) {
              $('.home .wrapp-img').css("max-height", $('.mx-width').height());
              $(".home .first-section").css("height", windowHeight).addClass('bk-none');
              $('.rlt .background').css({"height": (windowHeight - $('.wrapp-bottom').outerHeight() - $('.navigation-wrapper').outerHeight()), "width" : $('.rlt').width(), "margin-top": $('.navigation-wrapper').height() });
            }
          });
          $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            var scrollHalf = parseInt($(window).scrollTop() / 3);
            var value = (bkWidth - scrollHalf);

            if (scroll >= 50) {
              $('.home .first-section').addClass("bk-white");
              if (windowWidth >= 991 && $('.home .first-section').hasClass("bk-white")) {
                $('.rlt .background').css({"width": value});
              }
            }
            else {
              if (windowWidth >= 991) {
                $('.rlt .background').css({"width": bkWidth});
              }
              $('.home .first-section').removeClass("bk-white");
            }
          });
          $('#scroll-to').on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({scrollTop: $('.second-section').offset().top}, 500);
          });

          // animate svg camere
          var artale = new Vivus('artale', {duration: 100});
          var moncada = new Vivus('moncada', {duration: 100});
          var gioeni = new Vivus('gioeni', {duration: 100});

          var homeGallery = new Swiper('.swiper-container', {
              // Optional parameters
              slidesPerView: 'auto',
              centeredSlides: true,
              freeMode: true,
              spaceBetween: 30,
              mousewheel: true,
              releaseOnEdges: true,
              navigation: {
                nextEl: '.dimora-button-next',
                prevEl: '.dimora-button-prev',
              },
              breakpoints: {
              992: {
                slidesPerView: 1,
                centeredSlides: false,
                freeMode: false,
              },

            },
          });
          $('.swiper-container').on('mouseover', function() {
              $(document).bind('mousewheel', function(e){
                if(e.originalEvent.wheelDelta / 120 > 0) {
                  if (!homeGallery.mousewheel.enabled) {
                    homeGallery.mousewheel.enable();
                  }
                  else {
                    homeGallery.on('reachBeginning', function() {
                        homeGallery.mousewheel.disable();
                    });
                  }
                }
                else {
                  if (!homeGallery.mousewheel.enabled) {
                    homeGallery.mousewheel.enable();
                  }
                  homeGallery.on('reachEnd', function() {
                      homeGallery.mousewheel.disable();
                  });
                }
              });
            });
        }
        // PAGE camere
        function initPageCamere() {
          function galleryAnimation(index) {
            $('.list-active-slide .nav li').removeClass('active');
            $('.list-active-slide .nav li#list'+index).addClass("active");
            $('.wrapp-camera .title-slide').removeClass('fadeInUp').hide();
            $('.wrapp-camera .subtitle-slide').removeClass('fadeInUp delay1').hide();
            $('.wrapp-camera .url-slide').removeClass('fadeInUp delay2').hide();
            $('#title'+index).addClass('fadeInUp').fadeIn(300);
            $('#subtitle'+index).addClass('fadeInUp delay1').fadeIn(300);
            $('#url'+index).addClass('fadeInUp delay2').fadeIn(300);
          }
          var verticalGallery = new Swiper('.swiper-container', {
              // Optional parameters+
              freeMode: true,
              effect : 'fade',
              fadeEffect: { crossFade: true },
              mousewheel: true,
              releaseOnEdges: true,
              navigation: {
                nextEl: '.button-next',
                prevEl: '.button-prev',
              },
          });
          $('.list-active-slide .list-opacity a').on('click', function(e) {
            e.preventDefault();
            var slideIndex = $(this).data('gallery');
            verticalGallery.slideTo(slideIndex);
          });
          $('.wrapp-camera .title-slide').not(':first').hide();
          $('.wrapp-camera .subtitle-slide').not(':first').hide();
          $('.wrapp-camera .url-slide').not(':first').hide();
          $('.wrapp-camera').on('mouseover', function() {
            $(this).bind('mousewheel', function(e){
              if(e.originalEvent.wheelDelta / 120 > 0) {
                if (!verticalGallery.mousewheel.enabled) {
                  verticalGallery.mousewheel.enable();
                }
                else {
                  verticalGallery.on('reachBeginning', function() {
                    verticalGallery.mousewheel.disable();
                  });
                }
              }
              else {
                verticalGallery.mousewheel.enable();
                verticalGallery.on('reachEnd', function() {
                    verticalGallery.mousewheel.disable();
                });
              }
            });
          });
          verticalGallery.on('slideChange', function() {
            var slideIndex = verticalGallery.activeIndex;
            galleryAnimation(slideIndex);
          });

          $(window).on('scroll resize', function() {
            if ($('.small-visualization').is(':visible') && $(window).width() <= 767) {
              var wHeight = $(window).height();
              var scroll = $(window).scrollTop();
              var scrollBottom = scroll + wHeight + 200;
              var artale = $("#room0").offset().top;
              var doria = $("#room1").offset().top;
              var gioeni = $("#room2").offset().top;
              var valueScroll = 0;
              if (scrollBottom < doria) {
                scroll = scroll / 20;
                $("#room0 img").css("top", "-"+scroll+"%");
              }
              else if (scrollBottom >= artale && scrollBottom < gioeni) {
                scroll = scroll / 30;
                $("#room1 img").css("top", "-"+scroll+"%");
              }
              else if (scrollBottom >= doria) {
                scroll = scroll / 50;
                $("#room2 img").css("top", "-"+scroll+"%");
              }
            }
            else {
              $(".parallax").css("top", "0");
            }
          });
        }

        var showMap;
        var marker;
        function initMap() {
            var pos = {lat: 37.502970, lng: 15.091870};
            showMap = new google.maps.Map(document.getElementById('map'), {
                center: pos,
                zoom: 18,
                zoomControl: true,
                mapTypeControl: true,
                draggable: true,
                scaleControl: false,
                scrollwheel: false,
                streetViewControl: true
            });
            var stylez = [
              {
                  "featureType": "all",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "weight": "2.00"
                      }
                  ]
              },
              {
                  "featureType": "all",
                  "elementType": "geometry.stroke",
                  "stylers": [
                      {
                          "color": "#9c9c9c"
                      }
                  ]
              },
              {
                  "featureType": "all",
                  "elementType": "labels.text",
                  "stylers": [
                      {
                          "visibility": "on"
                      }
                  ]
              },
              {
                  "featureType": "administrative.country",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "saturation": "32"
                      },
                      {
                          "weight": "1.07"
                      }
                  ]
              },
              {
                  "featureType": "administrative.locality",
                  "elementType": "labels.text.stroke",
                  "stylers": [
                      {
                          "weight": "0.52"
                      }
                  ]
              },
              {
                  "featureType": "administrative.neighborhood",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "color": "#04273b"
                      }
                  ]
              },
              {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "lightness": "100"
                      }
                  ]
              },
              {
                  "featureType": "landscape",
                  "elementType": "all",
                  "stylers": [
                      {
                          "color": "#f2f2f2"
                      }
                  ]
              },
              {
                  "featureType": "landscape",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#e7e7e7"
                      }
                  ]
              },
              {
                  "featureType": "landscape.man_made",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#fafafa"
                      }
                  ]
              },
              {
                  "featureType": "poi",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "all",
                  "stylers": [
                      {
                          "saturation": -100
                      },
                      {
                          "lightness": 45
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#eeeeee"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "color": "#8d8d8d"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "labels.text.stroke",
                  "stylers": [
                      {
                          "color": "#ffffff"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "simplified"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "weight": "0.50"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#cdc9c9"
                      },
                      {
                          "lightness": "14"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "geometry.stroke",
                  "stylers": [
                      {
                          "saturation": "1"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "weight": "1.19"
                      },
                      {
                          "color": "#8d8d8d"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "labels.icon",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "color": "#8d8d8d"
                      }
                  ]
              },
              {
                  "featureType": "transit",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "all",
                  "stylers": [
                      {
                          "color": "#46bcec"
                      },
                      {
                          "visibility": "on"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#8D8D8D"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "geometry.stroke",
                  "stylers": [
                      {
                          "lightness": "-14"
                      },
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "color": "#ffffff"
                      },
                      {
                          "weight": "0.01"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "labels.text.stroke",
                  "stylers": [
                      {
                          "color": "#ffffff"
                      },
                      {
                          "saturation": "-1"
                      },
                      {
                          "gamma": "0.00"
                      }
                  ]
              }
            ];
            var mapType = new google.maps.StyledMapType(stylez, { name:"Grayscale" });
            showMap.mapTypes.set('tehgrayz', mapType);
            showMap.setMapTypeId('tehgrayz');
            marker = new google.maps.Marker({
                map: showMap,
                draggable: true,
                animation: google.maps.Animation.DROP,
                position: pos,
            });
            marker.addListener('click', toggleBounce);
        }
        function toggleBounce(){
              if(marker.getAnimation() !== null){
                  marker.setAnimation(null);
              }else{
                  marker.setAnimation(google.maps.Animation.BOUNCE);
              }
          }

        // SINGLE ROOM
        function initSingleRoom() {
          var singleGallery = new Swiper('#gallery-room', {
              // Optional parameters+
              slidesPerView: 'auto',
              autoHeight: true, /* to adapt arrows for both landscape and portrait pictures */
              centeredSlides: true,
              freeMode: true,
              spaceBetween: 30,
              mousewheel: true,
              releaseOnEdges: true,
              navigation: {
                nextEl: '.dimora-button-next',
                prevEl: '.dimora-button-prev',
              },
              breakpoints: {
              992: {
                slidesPerView: 1,
                freeMode: false,
              },
            },
          });
          $('#gallery-room').on('mouseover', function() {
            $(this).bind('mousewheel', function(e){
              if(e.originalEvent.wheelDelta / 120 > 0) {
                if (!singleGallery.mousewheel.enabled) {
                  singleGallery.mousewheel.enable();
                }
                else {
                  singleGallery.on('reachBeginning', function() {
                    singleGallery.mousewheel.disable();
                  });
                }
              }
              else {
                singleGallery.mousewheel.enable();
                singleGallery.on('reachEnd', function() {
                    singleGallery.mousewheel.disable();
                });
              }
            });
          });
          if ($('.wrapp-all-content').hasClass('single-room')) {
            var mobileGallery = new Swiper('#mobile-gallery', {
              slidesPerView: 3,
              breakpoints: {
                // when window width is <= 320px
                480: {
                  slidesPerView: 1,
                },
                // when window width is <= 480px
                640: {
                  slidesPerView: 2,
                }
              },
              navigation: {
                nextEl: '.dimora-mobile-button-next',
                prevEl: '.dimora-mobile-button-prev',
              },
            });
            offsetTop = 150;
            leftPanel = $('.left-info-panel').height() + offsetTop;
            contentToFix = $('.wrapper-two-section').height() + $('.wrapper-two-section').offset().top;
            var offsetTop, leftPanel, contentToFix;
            if (($(window).scrollTop() + leftPanel) >= contentToFix) {
              $('.left-info-panel').addClass('absolute');
            }else {
              $('.left-info-panel').removeClass('absolute');
            }
            $(window).on('load resize', function() {
              leftPanel = $('.left-info-panel').height() + offsetTop;
              contentToFix = $('.wrapper-two-section').height() + $('.wrapper-two-section').offset().top;
            });
            $(window).on('scroll', function() {
              var scrl = $(window).scrollTop() + leftPanel;
              if(scrl >= contentToFix) {
                $('.left-info-panel').addClass('absolute');
              }
              else {
                $('.left-info-panel').removeClass('absolute');
              }
            });
          }
        }
        // PAGE FANCY STAY
        function initFancyStay() {
          var fancyGallery = new Swiper('#gallery-fancy', {
              // Optional parameters+
              slidesPerView: 'auto',
              centeredSlides: true,
              freeMode: true,
              spaceBetween: 30,
              mousewheel: true,
              releaseOnEdges: true,
              navigation: {
                nextEl: '.dimora-button-next',
                prevEl: '.dimora-button-prev',
              },
              breakpoints: {
              992: {
                slidesPerView: 1,
                freeMode: false,
                centeredSlides: false,
                spaceBetween: 0,
              },
            },
          });
          $('#gallery-fancy').on('mouseover', function() {
            $(this).bind('mousewheel', function(e){
              if(e.originalEvent.wheelDelta / 120 > 0) {
                if (!singleGallery.mousewheel.enabled) {
                  singleGallery.mousewheel.enable();
                }
                else {
                  singleGallery.on('reachBeginning', function() {
                    singleGallery.mousewheel.disable();
                  });
                }
              }
              else {
                singleGallery.mousewheel.enable();
                singleGallery.on('reachEnd', function() {
                    singleGallery.mousewheel.disable();
                });
              }
            });
          });
        }

        var Camere = Barba.BaseView.extend({
          namespace: 'camere',
          onEnter: function() {
              // The new Container is ready and attached to the DOM.
          },
          onEnterCompleted: function() {
              // The Transition has just finished.
              checkLinkActive();
              initMenu();
              initPageCamere();
          }
        });
        var Contacts = Barba.BaseView.extend({
          namespace: 'contatti',
          onEnter: function() {
              // The new Container is ready and attached to the DOM.
          },
          onEnterCompleted: function() {
              // The Transition has just finished.
              checkLinkActive();
              initMenu();
              if ($('#map') && $(window).on('load')) {
                initMap();
              }
          }
        });
        var FancyStay = Barba.BaseView.extend({
          namespace: 'fancy-stay',
          onEnter: function() {
              // The new Container is ready and attached to the DOM.
          },
          onEnterCompleted: function() {
              // The Transition has just finished.
              checkLinkActive();
              initFancyStay();
              initMenu();
          }
        });
        var SingleRoom = Barba.BaseView.extend({
          namespace: 'single-room',
          onEnter: function() {
              // The new Container is ready and attached to the DOM.
          },
          onEnterCompleted: function() {
              // The Transition has just finished.
              checkLinkActive();
              initMenu();
              initSingleRoom();
          }
        });
        var Home = Barba.BaseView.extend({
          namespace: 'home',
          onEnter: function() {
              // The new Container is ready and attached to the DOM.
          },
          onEnterCompleted: function() {
              // The Transition has just finished.
              checkLinkActive();
              initMenu();
              initHome();
          }
        });

        Barba.Dispatcher.on('linkClicked', function(el) {
           lastElementClicked = el;
        });
        var TheTransition = Barba.BaseTransition.extend({
          start: function() {
            var _this = this;
            function initLoad() {
              
              /*
              $('.to-top, .to-bottom').addClass('half-height');
              */
              $('.wrapp-general-loader').fadeIn(function(){
                $('html').addClass('no-overflow');
                $(_this.oldContainer).animate({ opacity: 0 }, 100);
                $('.first-loader').delay(100).fadeIn();
              });
              setTimeout(function() {
                $('.progressbar').addClass('full-width');
              }, 500);
              $('.progressbar').addClass('done');
              if($('.progressbar').hasClass('done')) {
                return _this.finish.bind(_this);
              }
              
            }
            this.newContainerLoading.then(initLoad());
          },

          finish: function() {
            $("html, body").animate({ scrollTop: 0 });
            var _this = this;
            var $el = $(_this.newContainer);
            if($('.wrapp-general-loader').is(':visible')){
              setTimeout(function() {
                $(_this.oldContainer).hide();

                /*$('.to-top, .to-bottom').delay(300).removeClass('half-height');*/
                $('.first-loader').fadeOut(function() {
                  $('html').removeClass('no-overflow');                  
                  $('.wrapp-general-loader').delay(100).fadeOut();
                });  
                _this.done();
                $('.progressbar').removeClass('full-width done');
              }, 800);
            }
            /*
            if($('.to-top').hasClass('half-height')) {
              setTimeout(function() {
                $(_this.oldContainer).hide();
                $('html').removeClass('no-overflow');
                $('.to-top, .to-bottom').delay(300).removeClass('half-height');
                _this.done();
                $('.progressbar').removeClass('full-width done');
              }, 800);
            }*/
          }
        });
        var WindowTransition = Barba.BaseTransition.extend({
          start: function() {
            var _this = this;
            function initLoad() {

                $('.cloned').remove();
                var $svg = $(lastElementClicked).parents('.col-md-4');
                $svg = $svg.find('.wrapp-room');
                var width = $svg.width();
                var position = $svg.offset();
                $svg.clone().removeClass('wow').addClass('cloned').appendTo("#barba-wrapper");
                $('.cloned').attr("style", "");
                $('.cloned').css({"top": position.top, "left" : position.left, "width": "144px"});
                $(_this.oldContainer).animate({ opacity: 0 }, 200);
                $("html, body").animate({ scrollTop: 0 }, 700);
                $('.cloned').animate({"top": "150px", "left": "60px", "width": "144px"}, 700);
                return _this.finish.bind(_this);

            }
            this.newContainerLoading.then(initLoad());
          },

          finish: function() {
            var _this = this;
            var $el = $(_this.newContainer);
            setTimeout(function() {
              $(_this.oldContainer).hide();
              $('.cloned').fadeOut();
              _this.done();
            }, 400);
          }
        });
        Barba.Pjax.getTransition = function() {
          /**
           * Here you can use your own logic!
           * For example you can use different Transition based on the current page or link...
           */
          if ($(lastElementClicked).hasClass('to-single') && $(window).width() >= 991) {
            Barba.Pjax.cacheEnabled = false;
            return WindowTransition;
          }
          return TheTransition;
        };
        // Init the view!
        Camere.init();
        Contacts.init();
        FancyStay.init();
        SingleRoom.init();
        Home.init();
        //Please note, the DOM should be ready
        Barba.Pjax.start();
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        // All code here is esecuted on first access
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'camere': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        // // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'contatti': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        // // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'fancy_stay': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        // // JavaScript to be fired on all pages, after page specific JS is fired
      },
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  if ($('.barba-container').data('namespace') === "common") {

    var links = $('a[href]');
    var cbk = function(e) {
     if(e.currentTarget.href === window.location.href) {
       e.preventDefault();
       e.stopPropagation();
     }
    };
    for(var i = 0; i < links.length; i++) {
      links[i].classList.add("no-barba");
    }

    $('#fullscreen').on('click', function() {
      $(this).toggleClass('is-active');
      $('main').toggleClass('opacity');
      $('#fullscreen-menu').slideToggle();
      $('#fullscreen-menu .nav li').each(function(index, element) {
        $(this).toggleClass('animated fadeInUp delay'+(index + 1)+'');
      });
      $('html').toggleClass('no-overflow');
    });
  }


})(jQuery); // Fully reference jQuery after this point.
